<template>
  <div>
    <h5>Transactions</h5>
    <div :class="`${Loading ? 'disable' : ''}`">
      <div class="border rounded p-1 mb-3">
        <legend class="pl-2 mb-0">Filters:</legend>
        <div
          id="first-row"
          style="display: grid; grid-template-columns: 1fr 1fr; gap: 100px;"
          class="rounded"
        >
          <div class="d-flex align-items-center p-2">
            <label for="" style="white-space: nowrap;" class="mr-1 mb-0"
              >Clients: <span style="color: red;">*</span></label
            >
            <select
              class="form-control"
              name=""
              id=""
              multiple
              size="7"
              @change="clearBillTo"
              v-model="filters.client_selected"
            >
              <option
                :value="client"
                v-for="(client, idx) in clients"
                :key="idx"
                >{{ client.name }}</option
              >
            </select>
          </div>

          <div>
            <div class="d-flex align-items-center p-2">
              <label
                for=""
                style="white-space: nowrap; flex-grow: 1;"
                class="mr-1 mb-0"
                >Bill To: <span style="color: red;">*</span></label
              >
              <select
                class="form-control"
                name=""
                id=""
                style="max-width: 75%;"
                v-model="filters.bill_to"
              >
                <option
                  :value="client"
                  v-for="(client, idx) in filters.client_selected"
                  :key="idx"
                  >{{ client.name }}</option
                >
              </select>
            </div>
            <div class="d-flex align-items-center p-2">
              <label
                for=""
                style="white-space: nowrap; flex-grow: 1;"
                class="mr-1 mb-0"
                >Start Date: <span style="color: red;">*</span></label
              >
              <a-date-picker
                format="MM/DD/YYYY"
                id="startDate"
                style="max-width: 75%;"
                v-model="filters.start_date"
              />
            </div>
            <div class="d-flex align-items-center p-2">
              <label
                for=""
                style="white-space: nowrap; flex-grow: 1;"
                class="mr-1 mb-0"
                >End Date: <span style="color: red;">*</span></label
              >
              <a-date-picker
                format="MM/DD/YYYY"
                id="endDate"
                style="max-width: 75%;"
                v-model="filters.end_date"
              />
            </div>
          </div>
        </div>
        <button
          class="btn btn-primary m-2 mt-1"
          type="button"
          @click="fetchData"
        >
          Submit
        </button>
      </div>
      <div class="border rounded p-2" v-if="getTransactionReportData">
        <div id="second-row" class="pl-2 mb-1">
          <div class="d-flex align-items-center">
            <!-- <div
          style="width: 75px; height: 75px; background-color: grey; border-radius: 50%;
      "
          class="mr-3"
        ></div> -->
            <div style="width: 100%;">
              <div class="d-flex align-items-center">
                <p class="mb-0" style="flex-grow: 1;">
                  <span class="bold">Clients: </span
                  ><span>{{ getClientByIdData.name }}</span>
                </p>
                <button
                  @click="getInvoice"
                  type="button"
                  class="btn btn-primary mb-2"
                >
                  Get Invoice
                </button>
              </div>
              <!-- <p class="mt-1" style="text-decoration: underline;">
              {{ getClientByIdData.taico_email }}
            </p> -->
              <p>
                <span class="bold">Programs & Contests: </span><span>All</span>
              </p>
              <p><span class="bold">User Codes: </span><span>All</span></p>
              <p>
                <span class="bold">Transaction Types: </span
                ><span>CREDIT, ORDER, ORDER TAX, CREDIT TAX</span>
              </p>
              <p>
                <span class="bold">Total Points: </span
                ><span>{{
                  getTransactionReportData.total_points.toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                    }
                  )
                }}</span>
              </p>
              <p>
                <span class="bold">Total Records: </span
                ><span>{{ getTransactionReportData.total_records }}</span>
              </p>
            </div>
          </div>
        </div>

        <!-- <div
        id="third-row"
        class="p-2 rounded mb-3"
        style="display: grid; grid-template-columns: 1fr 1fr; background-color: #F0F9FF;"
      >
        <div>
          <label for="">Maintenance Balance: </label>
        </div>
        <div>
          <label for="">Interval Payments: </label>
        </div>
        <div>
          <label for="">Starting Balance: </label>
        </div>
        <div>
          <label for=""> Interval Admin Fee: </label>
        </div>
      </div> -->

        <div class="d-flex mb-2">
          <span style="flex-grow: 1;"></span>
          <div class="d-flex align-items-center">
            <span class="mr-1">Show </span>
            <select class="form-control" v-model.number="filters.pg_size">
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
            <span class="ml-1 mr-1"> entries</span>
          </div>
        </div>

        <h6 class="ml-1">
          Transaction Report for {{ getClientByIdData.name }}
        </h6>
        <table class="table table-striped rounded border table-hover">
          <thead class="border">
            <tr>
              <th>Date</th>
              <th>Order Number</th>
              <th>Employee</th>
              <th>Item</th>
              <th>Type</th>
              <!-- <th>Markup Ratio</th> -->
              <th>Dollars</th>
              <th>Points</th>
            </tr>
          </thead>
          <template v-if="getTransactionReportData.transaction_records">
            <tbody class="border">
              <tr
                v-for="(transaction,
                idx) in getTransactionReportData.transaction_records"
                :key="idx"
              >
                <!-- date -->
                <td class="white-space">
                  {{ moment(transaction.date).format("MM/DD/YYYY hh:mm A") }}
                </td>

                <!-- order number -->
                <td class="white-space ">
                  {{ transaction.order_number }}
                </td>

                <!-- Employee Name -->
                <td class="white-space" @click="setName(transaction)">
                  <router-link
                    :to="{
                      name: 'DivvyAdminUsersReportUser',
                      params: {
                        id: transaction.user_id,
                      },
                    }"
                  >
                    {{ transaction.first_name }} {{ "" }}
                    {{ transaction.last_name }}
                  </router-link>
                </td>

                <!-- Item -->
                <td class="">
                  {{ transaction.product_name }}
                </td>

                <!-- Type -->
                <td>{{ transaction.type }}</td>

                <!-- Markup Ratio -->
                <!-- <td></td> -->

                <!-- Dollars -->
                <td class="white-space text-right">
                  {{
                    transaction.type === "order" ||
                    transaction.type === "points subtracted" ||
                    transaction.type === "order tax"
                      ? "-"
                      : ""
                  }}{{
                    Number(transaction.dollars).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                    })
                  }}
                </td>

                <!-- Points -->
                <td class="white-space text-right">
                  <span
                    v-if="
                      transaction.type === 'order' ||
                        transaction.type === 'points subtracted' ||
                        transaction.type === 'order tax'
                    "
                    class="badge badge-danger pl-1 pr-1"
                  >
                    -{{
                      Number(transaction.points).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    }}</span
                  >
                  <span v-else class="badge badge-success pl-1 pr-1">{{
                    Number(transaction.points).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                    })
                  }}</span>
                </td>
              </tr>
            </tbody>

            <tfoot class="border">
              <tr>
                <td colspan="4" class="text-right bold">
                  Total Points:
                </td>
                <td class="bold">
                  {{
                    getTransactionReportData.total_points.toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                      }
                    )
                  }}
                </td>
                <td class="bold"></td>
              </tr>
            </tfoot>
            <tfoot class="border">
              <tr>
                <td colspan="4" class="text-right bold">
                  Total Amount:
                </td>
                <td class="bold">
                  {{
                    Number(
                      (
                        (1 / getClientByIdData.ratio) *
                        getTransactionReportData.total_points
                      ).toFixed(2)
                    ) > 0
                      ? "$" +
                        Number(
                          (
                            (1 / getClientByIdData.ratio) *
                            getTransactionReportData.total_points
                          ).toFixed(2)
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })
                      : "-$" +
                        Math.abs(
                          Number(
                            (
                              (1 / getClientByIdData.ratio) *
                              getTransactionReportData.total_points
                            ).toFixed(2)
                          )
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })
                  }}
                </td>
                <td class="bold"></td>
              </tr>
            </tfoot>
          </template>

          <template v-if="!getTransactionReportData.transaction_records">
            <tbody class="border">
              <tr>
                <td colspan="7">No records to display</td>
              </tr>
            </tbody>

            <tfoot></tfoot>
          </template>
        </table>
        <div class="d-flex justify-content-between mt-2">
          <div>
            <span
              v-if="getTransactionReportData.transaction_records === null"
              class="ml-2"
              >Showing 0 to 0 of 0 entries</span
            >
            <span v-else
              >Showing
              {{
                (filters.pg_num - 1) * getTransactionReportData.page_size + 1
              }}
              to
              {{
                (filters.pg_num - 1) * getTransactionReportData.page_size +
                  getTransactionReportData.selected_record_count
              }}
              of
              {{ getTransactionReportData.total_records }} entries</span
            >
          </div>
          <div v-if="getTransactionReportData.transaction_records">
            <pagination
              :data="getTransactionReportData.transaction_records"
              :totalPages="
                Math.ceil(
                  getTransactionReportData.total_records / filters.pg_size
                )
              "
              :total="getTransactionReportData.total_records"
              :perPage="filters.pg_size"
              :currentPage="filters.pg_num"
              @pagechanged="onPageChange"
            />
          </div>
        </div>

        <div v-if="this.getTransactionReportData.sub_total_details != null">
          <div
            v-if="this.getTransactionReportData.sub_total_details.length > 0"
          >
            <div
              class="mt-2"
              v-for="subTotal in this.getTransactionReportData
                .sub_total_details"
              :key="subTotal.id"
            >
              <h6 class="ml-1">Subtotal by {{ subTotal.display_name }}</h6>

              <table
                class="table table-bordered table-hover"
                v-if="subTotal.type !== 'product'"
              >
                <thead>
                  <tr>
                    <th v-if="subTotal.type === 'client'">Client</th>
                    <th v-if="subTotal.type === 'bywhom'">
                      User (Username)
                    </th>
                    <th v-if="subTotal.type === 'code'">Code</th>
                    <th v-if="subTotal.type === 'program'">
                      Programs & Contests
                    </th>

                    <th>Added</th>
                    <th>Credits</th>
                    <th>Credit Taxes</th>
                    <th>Subtracted</th>
                    <th>Orders</th>
                    <th>Order Taxes</th>
                    <th>Rebate</th>
                    <th>Total</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-if="subTotal.records === null">
                    <td colspan="9">No records to display</td>
                  </tr>
                  <tr
                    v-for="trans in subTotal.records"
                    :key="trans.index"
                    v-else
                  >
                    <td>{{ trans.entity_name }}</td>
                    <td>{{ trans.added.toLocaleString("en-US") }}</td>
                    <td>{{ trans.credits.toLocaleString("en-US") }}</td>
                    <td>
                      {{ trans.credit_taxes.toLocaleString("en-US") }}
                    </td>
                    <td>
                      {{ trans.subtracted.toLocaleString("en-US") }}
                    </td>
                    <td>{{ trans.orders.toLocaleString("en-US") }}</td>
                    <td>
                      {{ trans.order_taxes.toLocaleString("en-US") }}
                    </td>
                    <td>{{ trans.rebate.toLocaleString("en-US") }}</td>
                    <td>{{ trans.total.toLocaleString("en-US") }}</td>
                  </tr>
                </tbody>
                <tfoot v-if="subTotal.total_info && subTotal.records">
                  <tr>
                    <td>{{ subTotal.total_info.entity_name }}</td>
                    <td>
                      {{ subTotal.total_info.added.toLocaleString("en-US") }}
                    </td>
                    <td>
                      {{ subTotal.total_info.credits.toLocaleString("en-US") }}
                    </td>
                    <td>
                      {{
                        subTotal.total_info.credit_taxes.toLocaleString("en-US")
                      }}
                    </td>
                    <td>
                      {{
                        subTotal.total_info.subtracted.toLocaleString("en-US")
                      }}
                    </td>
                    <td>
                      {{ subTotal.total_info.orders.toLocaleString("en-US") }}
                    </td>
                    <td>
                      {{
                        subTotal.total_info.order_taxes.toLocaleString("en-US")
                      }}
                    </td>
                    <td>
                      {{ subTotal.total_info.rebate.toLocaleString("en-US") }}
                    </td>
                    <td>
                      {{ subTotal.total_info.total.toLocaleString("en-US") }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="Loading === true">
        <div class="centered-spinner">
          <a-spin />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import pagination from "@/components/Pagination.vue";

export default {
  name: "Transactions",
  components: {
    pagination,
  },
  computed: {
    Loading() {
      return this.$store.state.transactions.Loading;
    },
    clients() {
      return this.$store.state.transactions.getClientsData;
    },
    getTransactionReportData() {
      return this.$store.state.transactions.getTransactionReportData;
    },
    getClientByIdData() {
      return this.$store.state.transactions.getClientByIdData;
    },
    filters() {
      return this.$store.state.transactions.filters;
    },
  },
  watch: {
    filters: {
      handler(newVal, oldVal) {
        if (this.getTransactionReportData.page_size !== newVal.pg_size) {
          this.fetchTransactionReportData();
        }
      },
      deep: true,
    },
  },
  methods: {
    clearBillTo() {
      this.$store.state.transactions.filters.bill_to = null;
    },
    onPageChange(page) {
      console.log("page changed", page);
      this.filters.pg_num = page;

      this.fetchTransactionReportData();
    },
    getInvoice() {
      this.$store.commit("transactions/TOGGLE_TAB", "invoices");

      this.$store.commit("invoices/SET_FILTERS", {
        client: this.filters.client_selected,
        sDate: this.filters.start_date,
        eDate: this.filters.end_date,
        bill_to: this.filters.bill_to,
        email: this.getClientByIdData.taico_email,
      });

      this.$store.commit("invoices/CLEAR_DATA");

      this.$store.commit("invoices/SET_DATA", {
        getTransactionReportData: this.getTransactionReportData,
        getClientByIdData: this.getClientByIdData,
      });
    },
    fetchData() {
      if (!this.filters.client_selected) {
        alert("Please select a client.");
        return;
      }

      if (!this.filters.bill_to) {
        alert("Please select bill to client.");
        return;
      }

      if (!this.filters.start_date || !this.filters.end_date) {
        alert("Please select a date range.");
        return;
      }

      if (this.filters.end_date.diff(this.filters.start_date, "month") > 6) {
        alert("Date range cannot be more than 6 months.");
        return;
      }

      this.$store.commit("transactions/TOGGLE_LOADING");
      this.$store
        .dispatch("transactions/getClientById", {
          clientId: this.filters.bill_to.id,
        })
        .catch((err) => alert(err.message))
        .finally(() => {
          this.$store.commit("transactions/TOGGLE_LOADING");
        });

      this.fetchTransactionReportData();
    },
    fetchTransactionReportData() {
      let client_ids = [];

      for (const client of this.filters.client_selected) {
        client_ids.push(client.id);
      }

      this.$store.commit("transactions/TOGGLE_LOADING");
      this.$store
        .dispatch("transactions/getTransactionReport", {
          params: {
            pg_num: this.filters.pg_num,
            pg_size: this.filters.pg_size,
          },
          data: {
            start_date:
              moment(this.filters.start_date).format("YYYY-MM-DD") +
              "T00:00:00.000Z",
            end_date:
              moment(this.filters.end_date).format("YYYY-MM-DD") +
              "T23:59:59.000Z",
            is_all_clients_selected: false,
            client_ids: client_ids,
            is_all_programs_selected: true,
            program_ids: [],
            is_all_user_code_selected: true,
            user_codes: [],
            is_all_transactions_selected: false,
            show_my_transaction: false,
            transaction_types: ["ORDER", "ORDER TAX", "CREDIT", "CREDIT TAX"],
            show_total: false,
            sort_on: "",
            sub_total_by: ["client"],
            export_to_excel: false,
            email: "",
          },
        })
        .then(() => {
          window.scrollTo(0, 420);
        })
        .catch((err) => {
          alert(err.data);
        })
        .finally(() => {
          this.$store.commit("transactions/TOGGLE_LOADING");
        });
    },
  },

  mounted() {
    this.$store.commit("transactions/TOGGLE_LOADING");
    this.$store.dispatch("transactions/getClients").finally(() => {
      this.$store.commit("transactions/TOGGLE_LOADING");
    });
  },
};
</script>

<style lang="scss" scoped>
.bold {
  font-weight: bold;
}
.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.disable {
  opacity: 0.5;
  pointer-events: none;
}
</style>
